var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M44,7H4c-1.657,0-3,1.343-3,3v28c0,1.657,1.343,3,3,3h40c1.657,0,3-1.343,3-3V10C47,8.343,45.657,7,44,7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    fill: "#FFFFFF",
    width: 8,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    fill: "#FFFFFF",
    width: 8,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    fill: "#FFFFFF",
    width: 8,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#269732",
    d: "M31.63,24.405c0.687,0,1.196,0,1.882,0c0.537,0,0.845,0.288,0.933,0.674 c0.015,0.065,0.023,0.133,0.023,0.205c0,0.072-0.008,0.14-0.023,0.206c-0.089,0.392-0.414,0.674-0.901,0.674c-0.68,0-1.25,0-1.914,0 L31.63,24.405L31.63,24.405z M34.22,22.415c0.013,0.059,0.02,0.122,0.02,0.187c0,0.066-0.007,0.128-0.02,0.187 c-0.1,0.455-0.463,0.624-0.933,0.624c-0.554,0-1.05,0-1.657,0v-1.623c0.845,0,0.833,0,1.689,0 C33.849,21.791,34.139,22.047,34.22,22.415L34.22,22.415z M38,14v17c0,1.657-1.343,3-3,3h-5v-6.795c0.022,0,5.163,0,5.185,0 c1.127-0.009,2.105-0.582,2.105-1.666c0-0.072-0.005-0.141-0.014-0.209c-0.113-0.814-0.882-1.322-1.896-1.4l0-0.039 c1.012-0.157,1.518-0.802,1.518-1.53c0-0.533-0.249-0.966-0.716-1.243c-0.56-0.331-1.194-0.323-1.769-0.323 c-0.866,0-3.549,0-4.413,0L30,17c0-1.657,1.343-3,3-3H38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#034D9B",
    d: "M10,25.566V17c0-1.657,1.343-3,3-3h5v17c0,1.657-1.34,3-2.996,3c-1.257,0-2.918,0-5.004,0v-7.025 c1.217,0.335,4.156,0.708,5.882,0.052c1.087-0.411,1.654-1.187,1.654-2.364v-3.867h-2.867v3.867c0,0.781-0.43,1.383-1.196,1.58 C12.485,26.498,11.036,26.067,10,25.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1031",
    d: "M20,21.698V17c0-1.657,1.343-3,3-3h5v17c0,1.657-1.342,3-2.998,3c-1.236,0-2.885,0-5.002,0v-7.696 c0.797,0.684,1.921,0.943,2.959,1.041c1.339,0.118,2.788,0.014,4.336-0.369v-1.41c-0.905,0.45-2.031,0.855-3.308,0.727 c-1.402-0.163-2.101-1.04-2.101-2.292c0-1.317,0.775-2.16,2.133-2.297c1.089-0.108,2.252,0.217,3.276,0.731v-1.411 c-1.434-0.354-2.679-0.448-3.854-0.4C22.245,20.682,20.906,20.92,20,21.698z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardJcb);
export default __webpack_public_path__ + "static/media/card_jcb.ba51d6adbed0e505d9c7378a5f610ecf.svg";
export { ForwardRef as ReactComponent };